import React, { useEffect } from 'react';

import { Page, Divider, Panel, Table } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import * as pt from 'propTypes';

import { StatusCell } from '../streams/cells';
import { selectPageData, selectPageParameters } from './selectors';
import * as store from './store';

function QueuePage({
  pageData,
  pageParameters,
  setPageSize,
  fetchQueue,
}) {
  const { t } = useTranslation();

  useEffect(() => { fetchQueue(); }, [fetchQueue]);

  return (
    <Page title={t('lunaStreamsQueue:название раздела')}>
      <Divider />
      <Panel>
        <Table
          {...pageData}
          {...pageParameters}
          columns={[
            { Header: t('lunaStreamsQueue:таблица.колонки.status'), accessor: 'status', Cell: StatusCell, width: 80 },
            { Header: t('lunaStreamsQueue:таблица.колонки.stream_id'), accessor: 'stream_id', width: 120 },
            { Header: t('lunaStreamsQueue:таблица.колонки.name'), accessor: 'name', width: 200 },
          ]}
          paginationType="sizeOnly"
          setPageSize={setPageSize}
        />
      </Panel>
    </Page>
  );
}

QueuePage.propTypes = {
  fetchQueue: PropTypes.func.isRequired,
  setPageSize: PropTypes.func,
  pageParameters: PropTypes.shape({
    pageSize: PropTypes.number,
    pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
  }),
  ...pt.pageData.propTypes,
};

QueuePage.defaultProps = {
  setPageSize: undefined,
  pageParameters: {
    pageSize: 25,
    pageIndex: 0,
    pageSizeOptions: [10, 25, 50],
  },
  ...pt.pageData.defaultProps,
};

export default connect((state) => ({
  pageData: selectPageData(state),
  pageParameters: selectPageParameters(state),
}), (dispatch) => ({
  fetchQueue: () => dispatch(store.fetchPageData),
  setPageSize: (pageSize) => dispatch(store.setPageSize(pageSize)),
}))(QueuePage);
